import React from "react";
import appConfig from "../../../config/app.config";


const staticAssetsUrl = appConfig.staticAssetsUrl;

const ContentUserProfilePage = () => {
    return (
        <div >
            <h2 className="text-xl font-bold">7.Profile Page</h2>
            <div>
                <p>In this section you would be able to view or edit your account and profile information. Please follow the steps given below to navigate to User profile section page. .</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/user_profile.png"} />
            </div>

            <div>
                <p> <span className="font-bold">7.1 </span> Click on User Name display icon present at the right-hand side corner of page header  </p>
                <p> <span className="font-bold">7.2 </span> On clicking, you would get two options in the form of a drop-down :- 1. User profile 2. Sign Out as shown above</p>
                <p> <span className="font-bold">7.3 </span> Click on User Profile Option to navigate to User profile page.</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/edit_user_profile.png"} />
            </div>

            <div>
                <p><span className="font-bold">7.4 </span> In User Profile Page Section, you can perform <span className="font-bold">four major actions</span> as explained below - </p>

                <h2><span className="font-bold">Action 1: View Customer Information</span></h2>
                <p>Steps to view documentation</p>

                <h2><span className="font-bold">Action 2: Edit Customer Information</span></h2>
                <p>Update your personal info (like first & last name, contact number or email Id) by clicking on the Edit button.  Follow the below steps to do so:</p>
                <p><span className="font-bold">Step 1: </span> Click on the <span className="font-bold">Edit</span> button to make the text fields editable.</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/confirm_user_profile.png"} />
            </div>

            <div>

                <p><span className="font-bold">Step 2:</span> Edit/Modify the values as per your choice, then click on <span className="font-bold">Confirm</span> button</p>
                <p><span className="font-bold">Step 3:</span> Post clicking on <span className="font-bold">Confirm</span> button, Success message will appear on page as shown below</p>

                <img className="pic" src={staticAssetsUrl + "user_manual/cancel_user_profile.png"} />
            </div>

            <div>
                <h2><span className="font-bold">Action 3: View Account Information</span></h2>
                <p> View information related to your developer account (i.e iv-user, Customer Id, Customer Account Number, Email Id, Developer Created By, Developer Created On).</p>
                <h2><span className="font-bold">Action 4: Change Password Option </span></h2>
                <p>You can change the account current password by clicking on the <span className="font-bold">Change Password</span> button.</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/changePasswordImage.png"} />
            </div>

            <div>
                <h2>This page contains 3 fields -</h2>
                <p>1. Current Password - You should enter current Password which is in use</p>
                <p>2. New Password - You should enter a new password as per your choice</p>
                <p>3. Confirm New Password - You should re-enter the same new password for confirmation.</p>

            </div>

            <div>
                <p>Please note that all the three fields mentioned above are mandatory. Also, please ensure that the new password is different from the current password. </p>
                <p>Post entering all the three inputs please click on <span className="font-bold">Change Password</span> button.</p>
                <p>Note: Post successful password change, all the ongoing browser sessions will be logged-out automatically and the screen will be redirected to Login Page.</p>

            </div>

        </div>
    )
}

export default ContentUserProfilePage;